import { useState } from 'react'

import { useGetProducts } from '~/booking/hooks/useGetProduct'
import { CartKey } from '~/redux/slices/cart'

import { TutorLevel } from '~/types/booking'
import { Product } from '~/types/product'

import TutorLevels from './components/TutorLevels/TutorLevels'
import Products from './components/Products/Products'

export default function SelectTutoringProduct({
  includeTravelExpense,
  onClick,
  value,
  cart,
}: {
  includeTravelExpense: boolean
  onClick: (product: Product) => void
  value: Product | null
  cart?: CartKey
}): React.ReactElement {
  const [selectedLevel, setSelectedLevel] = useState<TutorLevel>(value ? value.tutorLevel : TutorLevel.TUTOR)

  const { data: bookingProducts } = useGetProducts(cart)
  const tutoringProducts = bookingProducts ? bookingProducts.tutoringProducts : []
  const tutoringProductLevels = tutoringProducts.map((v) => v.tutorLevel).filter((v, i, a) => a.indexOf(v) === i)
  const shouldFilterProducts = tutoringProductLevels.length > 1

  const filteredProducts = tutoringProducts.filter((elem) => !shouldFilterProducts || elem.tutorLevel === selectedLevel)

  return (
    <div>
      {shouldFilterProducts && (
        <TutorLevels onClick={(level) => setSelectedLevel(level)} selectedLevel={selectedLevel} />
      )}

      <Products
        includeTravelExpense={includeTravelExpense}
        onClick={onClick}
        products={filteredProducts}
        selectedProduct={value}
        showAllProducts={!shouldFilterProducts}
      />
    </div>
  )
}
